import React, { useState, useRef, useEffect } from 'react';

interface InfoTooltipProps {
  title: string;
  content: string;
  position?: 'left' | 'right' | 'center';
  width?: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  title,
  content,
  position = 'left',
  width = 'w-64',
}) => {
  const [show, setShow] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!show) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setShow(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [show]);

  const positionClass =
    position === 'right'
      ? 'right-0 left-auto'
      : position === 'center'
      ? 'left-1/2 -translate-x-1/2'
      : 'left-0';

  return (
    <div className="relative inline-flex items-center" ref={ref}>
      <button
        onClick={(e) => { e.stopPropagation(); setShow(v => !v); }}
        className="w-4 h-4 rounded-full bg-gray-600 text-gray-300 text-xs flex items-center justify-center hover:bg-blue-500 hover:text-white transition-colors leading-none flex-shrink-0 cursor-pointer"
        title={title}
        type="button"
      >
        i
      </button>
      {show && (
        <div
          className={`absolute top-5 z-30 ${positionClass} ${width} bg-gray-900 border border-gray-700 rounded-lg shadow-lg p-3 text-xs text-gray-300`}
        >
          <p className="font-semibold text-gray-200 mb-1">{title}</p>
          <p className="leading-relaxed">{content}</p>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;
